export const he = {
  nav: ['בית', 'קטלוג', 'על הייצור', 'סוכנים', 'מקרים', 'חדשות', 'תעודות', 'שאלות', 'צור קשר', 'סקירת מותג'],

  hero: {
    title1: 'חיסכון',
    title2: 'בדלק',
    subtitle: 'מערכות מימן לתחבורה וצי רכבים',
    feature1: 'חיסכון בדלק ומשאבים',
    feature2: 'התקנה ללא פגיעה באחריות',
    feature3: 'לכל מנועי בעירה פנימית: תחבורה מסחרית ופרטית',
    cta1: 'חשב חיסכון',
    cta2: 'הפוך לסוכן',
    disclaimer: 'אנו עובדים עם בעלים פרטיים וצי רכבים. כל החישובים והאפקטים — רק על בסיס הנתונים שלך.',
    bottomText: 'ערכים מאושרים על ידי מדידות — לכל רכב בנפרד',
  },

  benefits: {
    heading: 'חיסכון בדלק',
    subtitle1: 'יתרונות מערכת',
    subtitle2: 'מערכת',
    items: [
      { title: 'חיסכון בדלק 20–65%', description: 'התוצאות מאושרות על ידי מדידות על הציוד שלך. החזר השקעה — מ-12 עד 35 ימים', image: 'https://static3.tildacdn.com/tild6166-6232-4664-b137-336531346634/2_1.png' },
      { title: 'המנוע פועל חלק יותר וארוך יותר', description: 'פחות עומס, שחיקה מופחתת, ייצוב טמפרטורה מהנסיעות הראשונות', image: 'https://static3.tildacdn.com/tild3534-3066-4264-b464-303232656238/2_2.png' },
      { title: 'אין סיכונים לאחריות ולמנוע', description: 'התקנה לפי תקנות רשמיות, ללא שינויים מורכבים', image: 'https://static3.tildacdn.com/tild3061-6362-4164-b166-393539666330/2_3.png' },
      { title: 'תוצאות שקופות וניתנות למדידה', description: 'כל שלב מאושר על ידי מדידה לפני/אחרי תחת פיקוח מהנדס', image: 'https://static3.tildacdn.com/tild6463-3835-4734-b966-306132666339/2_4.png' },
    ],
  },

  howItWorks: {
    badge: '// איך_זה_עובד',
    title1: 'H2 ELEMENT',
    title2: 'גנרטור',
    description: 'גנרטור המימן H2 ELEMENT ממיר מים לתערובת מימן-חמצן ומזין אותה לצריכת המנוע יחד עם אוויר. התערובת מפעילה את תהליך הבעירה — הדלק משמש ביעילות רבה יותר.',
    engineLabel: 'מנוע',
    engineDesc: 'פועל במקביל לרכיבים הסטנדרטיים',
    mixLabel: 'תערובת H2+O2',
    mixDesc: 'אינו דורש כיול',
    viewProducts: 'צפה במוצרים',
    openPresentation: 'איך זה עובד?',
    steps: [
      { title: 'מפצל מים ל-H2 ו-O2', desc: 'פועל במקביל לרכיבים הסטנדרטיים' },
      { title: 'מתערבב עם אוויר בצריכה', desc: 'אינו דורש כיול' },
      { title: 'תערובת מועשרת נשרפת בגלילים', desc: 'אינו מפריע לאלקטרוניקת הרכב' },
      { title: 'יעילות בעירה טובה יותר', desc: 'הדלק משמש ביעילות רבה יותר' },
    ],
  },

  catalog: {
    badge: '// קטלוג_מוצרים',
    title1: 'קטלוג',
    title2: 'מוצרים',
    subtitle: 'כל הפתרונות עם אחריות רשמית והתקנה לפי תקני H2 ELEMENT',
    orderBtn: 'הזמן התקנה',
    installmentBtn: 'קנה בתשלומים',
    modalOrder: 'הזמן התקנה',
    modalInstallment: 'קנה בתשלומים',
    namePlaceholder: 'שמך',
    phonePlaceholder: 'מספר טלפון',
    emailPlaceholder: 'דואר אלקטרוני',
    submitBtn: 'שלח בקשה',
    products: [
      { id: 'h1c', series: 'PRO MAX', model: 'H1', price: '$3499', engineVolume: 'נפח מנוע עד 6L', dimensions: '230×100×285 מ"מ', warranty: 'אחריות 3 שנים', image: '/equipment-pro-max-single.png', vehicleTypes: ['car'] },
      { id: 'h2c', series: 'PRO MAX', model: 'H2', price: '$4499', engineVolume: 'נפח מנוע מ-6 עד 16L', dimensions: '265×100×285 מ"מ', warranty: 'אחריות 3 שנים', image: '/equipment-pro-max-double.png', vehicleTypes: ['car', 'truck'] },
    ],
  },

  production: {
    badge: '// ייצור',
    title1: 'ייצור',
    title2: 'עצמאי',
    description: 'חברתנו מבטיחה מחזור ייצור מלא של גנרטורי מימן — כל השלבים המרכזיים מרוכזים במתקן שלנו. החלה ב-2022, מאז 2026 עובדת על מערכת קו ייצור.',
    facilityTitle: 'מתקן ייצור מודרני',
    facilityDesc: 'עד 1,500 גנרטורים בחודש',
    boilerTitle: 'דוד מימן',
    boilerDesc: 'בנוסף למערכות תחבורה, הצוות שלנו מתכונן להשיק דוד מימן לחימום',
    stats: [
      { icon: 'factory', title: 'כושר ייצור', description: 'עד 1,500 גנרטורי H2 ELEMENT בחודש, תקני איכות קפדניים ובקרה בכל שלב' },
      { icon: 'shield', title: 'פיקוח הנדסי', description: 'מומחי החברה ומומחים מאשכולות מחקר תעשייתיים' },
      { icon: 'settings', title: 'ציוד מתקדם', description: 'קווי ריתוך, צביעה ובדיקות ביצועים מודרניים' },
      { icon: 'globe', title: 'גיאוגרפיית משלוחים', description: 'יצוא עולמי דרך רשת סוכנים נרחבת' },
      { icon: 'rocket', title: 'מחלקת מחקר ופיתוח עצמאית', description: 'מבטיחה עדכונים והרחבת קו המוצרים' },
    ],
  },

  dealerNetwork: {
    badge: '// רשת_עולמית',
    title1: 'רשת סוכנים',
    title2: 'ושירות',
    subtitle:
      'רשת הסוכנים והשירות המורשית של H2 ELEMENT פועלת בקנדה, בארה"ב, ב־12 מדינות באמריקה הלטינית, בישראל ובאוסטרליה.',
    becomeDealer: 'הפוך לסוכן',
    countries: [
      'קנדה',
      'ארה"ב',
      'מקסיקו',
      'גואטמלה',
      'פנמה',
      'קולומביה',
      'ונצואלה',
      'פרו',
      'בוליביה',
      "צ'ילה",
      'ארגנטינה',
      'אורוגוואי',
      'פרגוואי',
      'ברזיל',
      'ישראל',
      'אוסטרליה',
    ],
  },

  cases: {
    badge: '// מקרי_בוחן',
    title1: 'מקרי',
    title2: 'בוחן',
    getCases: 'קבל 50+ מקרים',
    before: 'לפני',
    after: 'אחרי',
  },

  dealers: {
    badge: '// תוכנית_סוכנים',
    title1: 'הפוך',
    title2: 'לסוכן',
    howToTitle1: 'איך',
    howToTitle2: 'להפוך',
    howToTitle3: 'לסוכן',
    requirementsTitle: 'דרישות לסוכן',
    requirements: [
      'קידום פעיל ופיתוח מותג באזור',
      'עמידה בתקנים וכללים של H2 ELEMENT',
      'גישה אחראית לתקשורת וניהול בקשות',
    ],
    becomeDealer: 'הפוך לסוכן',
    benefits: [
      { title: 'בלעדיות', description: 'האזור שלך מוקצה לך, ללא תחרות פנימית' },
      { title: 'כלים', description: 'סט מלא למכירות, שיווק, ניתוח ואוטומציה של זרימת עבודה' },
      { title: 'תקני עבודה', description: 'תקנות לפרסום, מבצעים, ניהול תקשורת' },
      { title: 'תמיכה מהירה', description: 'תשובות מהירות לכל השאלות' },
      { title: 'תנאים ברורים', description: 'מודל שקוף, ללא תשלומים נסתרים או רכישות כפויות' },
      { title: 'הכשרה', description: 'גישה לאקדמיית H2 ELEMENT — תוכנית קליטה שלב אחר שלב (60 ימים), חומרים, סרטונים, תמיכת מנחה' },
    ],
    steps: [
      { step: '01', title: 'מלא את הבקשה באתר', description: 'שלח את הטופס באתר; ניצור איתך קשר.' },
      { step: '02', title: 'קבל סקירה אישית', description: 'אנו דנים באזורך, קהל היעד והזדמנויות השיווק' },
      { step: '03', title: 'גישה לערכת התחלה', description: 'הכשרה, חומרים, מנהל ייעודי' },
      { step: '04', title: 'התחל למכור ולצמוח', description: 'עבוד עם המערכת שלנו, קבל תמיכה' },
    ],
  },

  dealerPackage: {
    title1: 'H2 ELEMENT',
    title2: 'חבילת סוכן',
    items: [
      { icon: 'engine', title: 'מוצר', description: 'מגוון, מקרי שימוש, מגבלות, תשובות לשאלות מרכזיות' },
      { icon: 'chart', title: 'פירוק יעדים', description: 'קביעת KPI פיננסיים ותפעוליים, תוכנית צמיחה שלב אחר שלב' },
      { icon: 'headset', title: 'מכירות', description: 'תסריטי שיחה, עיבוד לידים, עבודה עם CRM, תבניות הצעות' },
      { icon: 'package', title: 'אריזה', description: 'תקני פרופיל, עיצוב אתר, רשתות חברתיות, סגנון אחיד' },
      { icon: 'mobile', title: 'תוכן', description: 'תוכנית תוכן, הוראות לפוסטים, סרטונים, מקרים וביקורות' },
      { icon: 'people', title: 'תנועה', description: 'השקת פרסום, עבודה עם אתר וצ\'אטבוט, משפך לידים' },
      { icon: 'robot', title: 'כלי AI', description: 'שירותים ותבניות ליצירת חומרים מהירה ועיבוד לידים' },
      { icon: 'settings2', title: 'אוטומציה והרחבה', description: 'יישום CRM, בקרת תהליכים ומדדים, תבניות דיווח' },
    ],
  },

  news: {
    badge: '// עדכונים',
    title1: 'חדשות /',
    title2: 'אירועים',
    readMore: 'קרא עוד',
    items: [
      { title: 'גנרטורי דור חדש של H2 ELEMENT', date: '23.12.2025', description: 'עדכונים על קו המוצרים החדש של H2 ELEMENT.' },
      { title: 'אירוע הצגת H2 ELEMENT', date: '14.12.2025', description: 'אולם מלא ועניין רב באירוע ההצגה האחרון' },
      { title: 'הצגה גדולה של הדור החדש', date: '05.12.2025', description: 'הצגה בקנה מידה גדול של גנרטורי H2 ELEMENT מהדור החדש' },
      { title: 'כנס תעשייתי', date: '19.11.2025', description: 'נאספו יותר מ-200 משתתפים' },
      { title: 'כנס מנהלי צי רכבים', date: '11.10.2025', description: 'יזמים ובעלי צי רכבים למדו על טכנולוגיית המימן' },
      { title: 'היכרות עם טכנולוגיית H2', date: '06.09.2025', description: 'בעלי רכבים, לוגיסטיקה וציוד חקלאי הגיעו ללמוד על חיסכון בדלק של עד 65%' },
    ],
  },

  team: {
    badge: '// צוות',
    titleBefore: 'הצוות ',
    titleAccent: 'שלנו',
    whoTitle: 'מי אנחנו',
    whoBody: 'קבוצת יזמים המאוחדים סביב רעיון אחד.',
    missionTitle: 'המשימה שלנו',
    missionBody:
      'שימור הסביבה באמצעות טכנולוגיות מימן — לשפר את איכות החיים, לעזור לחסוך בדלק, להפחית פליטות פחמן ולהאריך את חיי המנוע.',
    roles: {
      founder: 'מייסד',
      productManager: 'מנהל מוצר',
    },
  },

  certificates: {
    title: 'תעודות',
    empty: 'אנחנו מעדכנים את הסעיף. תעודות רשמיות יפורסמו כאן בקרוב.',
  },

  faq: {
    badge: '// שאלות_נפוצות',
    items: [
      { question: 'האם זה בטוח למנוע?', answer: 'כן. הגנרטור אינו מפריע לעיצוב המנוע ואינו מחליף דלק — הוא פשוט משפר את הבעירה. המימן מפרק משקעי פחמן, כך שיש פחות פיח ואלמנטים שוחקים במנוע. המימן נשרף מהר יותר 8-10 פעמים בטמפרטורות נמוכות יותר, כך שהמנוע פועל חלק יותר ומתחמם פחות.' },
      { question: 'האם זה חוקי? האם צריך לרשום?', answer: 'לגמרי חוקי. גנרטור ה-HHO אינו דורש רישום מכיוון שהוא אינו שינוי בעיצוב הרכב. הוא פועל כמערכת נוספת ואינו מפר את כללי הפעלת הרכב.' },
      { question: 'עם אילו רכבים זה תואם?', answer: 'מתאים לכל סוגי מנועי הבעירה הפנימית: בנזין, דיזל, גז, מתאן (כולל LPG). ההתקנות שלנו משמשות את כולם — מרכבים פרטיים ועד משאיות, טרקטורים וציוד מיוחד. אנו בוחרים את הדגם לפי נפח המנוע — היעילות מובטחת.' },
      { question: 'איך זה עובד?', answer: 'לאחר הפעלת המנוע, הגנרטור מפעיל את תהליך האלקטרוליזה, המייצר גז HHO (תערובת מימן-חמצן, הנקרא גם גז בראון). גז זה מוזרם לתא הבעירה יחד עם אוויר ודלק. ה-HHO פועל כקטליזטור, מאיץ ומשפר את תהליך הבעירה של תערובת הדלק.' },
      { question: 'מה גורם לחיסכון בדלק?', answer: 'החיסכון נובע משיפור מאפייני הבעירה של תערובת אוויר-דלק על ידי הוספת HHO. ל-HHO יש דליקות גבוהה וטמפרטורת התלקחות נמוכה, המייזמת בעירה שלמה ואחידה יותר. זה מוביל ליעילות תרמית מוגברת, היווצרות פיח מופחתת, אובדן חום מופחת ויחס אוויר-דלק משופר.' },
      { question: 'כמה קשה ההתקנה?', answer: 'ההתקנה לוקחת בדרך כלל 60 עד 90 דקות. כל חשמלאי רכב או מכונאי יכול לבצע אותה — ההוראות הן שלב אחר שלב ופשוטות. אם משהו לא ברור — המהנדסים שלנו תמיד זמינים. אנו יכולים לעזור למצוא מתקין באזורך.' },
      { question: 'האם הגנרטור דורש תחזוקה?', answer: 'התחזוקה פשוטה ואינה דורשת ידע מיוחד. כל שצריך הוא להוסיף מים ומדי פעם לשטוף את המערכת. הוראות תחזוקה והתקנה מפורטות כלולות בכל ערכה.' },
      { question: 'האם יש אחריות?', answer: 'כן. אנו מייצרים את הגנרטורים בעצמנו ומספקים אחריות ל-3 שנים. אם משהו מתקלקל — נחליף ללא בעיות. אורך חיים — עד 10 שנים.' },
      { question: 'כמה זה עולה?', answer: 'המחיר תלוי בנפח המנוע. סדרה קלאסיק: H1 עד 2L — $750, H2 מ-2 עד 6.5L — $990, H3 מ-6.5 עד 12L — $1,650. סדרה חכמה: H2 מ-2 עד 6.5L — $1,320, H3 מ-6.5 עד 12L — $1,980, H4 מ-12 עד 20L — $2,640.' },
    ],
  },

  contact: {
    badge: '// צור_קשר',
    title: 'צור קשר',
    subtitle: 'מלא את טופס המשוב ואנו ניצור איתך קשר',
    phone: 'טלפון',
    email: 'דואר אלקטרוני',
    office: 'משרד ראשי',
    namePlaceholder: 'שמך',
    phonePlaceholder: 'מספר טלפון',
    emailPlaceholder: 'דואר אלקטרוני',
    messagePlaceholder: 'הודעתך',
    consent: 'אני מסכים לעיבוד נתונים אישיים',
    submitBtn: 'שלח בקשה',
    submitted: '// הבקשה_נשלחה',
    hours: 'שעות פעילות: תמיכה 24/7',
    response: 'זמן תגובה: < 2 שעות',
    formError: 'מלא את כל השדות.',
    invalidEmail: 'הזן כתובת אימייל תקינה.',
  },

  footer: {
    rights: 'כל_הזכויות_שמורות',
  },

  slides: {
    slide1: {
      eyebrow: 'מערכת חיסכון בדלק מימן',
      headline1: 'חסכו עד',
      headline2: 'מ',
      headline3: 'עלויות הדלק שלכם.',
      subtitle: 'כיצד לשחרר כוח ויעילות נסתרים במנוע שלך עם גנרטור מימן H2 ELEMENT.',
    },
    slide2: {
      image: '/slides/slide_02_he.png',
      eyebrow: 'הבעיה',
      headline: 'המנוע שלך מבזבז דלק בכל מחזור בעירה.',
      body: 'מחירי הדלק עולים, אבל הבעיה האמיתית נמצאת בתוך המנוע שלך. רוב מנועי הבעירה הפנימית מאבדים עד',
      body2: 'מהדלק עקב בעירה לא מלאה של תערובת האוויר-דלק.',
      tagline: 'אתה משלם על דלק שלעולם לא נוצל.',
    },
    slide3: {
      eyebrow: 'הפתרון',
      headline: 'הפתרון הוא שחרור כוח הבעירה המלאה.',
      body: 'מימן הוא אחד הגזים הדליקים ביותר. הוא נדלק באופן מיידי ובוער',
      body2: 'מהר יותר מדלק קונבנציונלי, ומשמש כזרז כדי להבטיח שתערובת האוויר-דלק כולה תישרף באופן מלא ויעיל.',
      fuelLabel: 'דלק',
      catalystLabel: 'זרז',
      cleanLabel: 'נקי',
    },
    slide5: {
      headline: 'התוצאות: חיסכון רב יותר, כוח רב יותר, מנוע בריא יותר.',
      prefix: 'עד',
      stats: [
        { label: 'הפחתה בצריכת\nהדלק' },
        { label: 'עלייה ב\nעוצמת המנוע' },
        { label: 'הפחתה בפליטת\nגזים מזיקים' },
      ],
    },
    slide6: {
      eyebrow: 'יתרונות',
      headline: 'המנוע שלך יפעל בשקט רב יותר, נקי יותר ועם יותר כוח.',
      bullets: [
        { title: 'כוח מוגבר', body: "הכוח עולה עד 30%, בולט במיוחד בסיבובים נמוכים. התגובה משתפרת ככל שמדף המומנט עובר למהירויות מנוע נמוכות יותר." },
        { title: 'מנוע נקי יותר', body: 'המימן פועל באופן פעיל לפירוק וניקוי משקעי פחמן קיימים, מפחית אלמנטים שוחקים בתוך המנוע.' },
        { title: 'פעולה חלקה וקרירה יותר', body: 'המנוע פועל חלק ושקט יותר. מימן בוער מהר יותר בטמפרטורות נמוכות יותר, המנוע מתחמם פחות, ומאריך את חייו השימושיים.' },
      ],
    },
    slide8: {
      eyebrow: 'בטיחות',
      headline: 'האם זה בטוח? בהחלט. הבטיחות מאושרת ומעוצבת במערכת.',
      body: 'הגז מיוצר לפי דרישה רק כאשר המנוע פועל. הוא נצרך מיד ו',
      bodyBold: 'אינו מאוחסן לעולם',
      body2: 'במערכת. אין מכל לחץ.',
      engineOn: 'מנוע פועל',
      engineOff: 'מנוע כבוי',
      active: 'פעיל',
      idle: 'לא פעיל',
    },
    slide9: {
      eyebrow: 'חוקיות',
      headline: 'האם זה חוקי? כן. אין צורך ברישום שינוי רכב.',
      body: 'גנרטור H2 ELEMENT אינו מפריע לעיצוב המקורי של המנוע או הרכב. הוא פועל כמערכת נוספת וחיצונית ואינו מפר את כללי הפעלת הרכב או התקנות.',
      badge: 'מערכת חיצונית — אין צורך ברישום',
      mobilePoints: [
        'גנרטור H2 ELEMENT אינו משנה את עיצוב המנוע או הרכב מהמפעל.',
        'הוא פועל כמערכת חיצונית נוספת לצד הרכב.',
        'אינו מפר את כללי התפעול או התקנות הרכב.',
        'אין צורך ברישום שינוי רכב.',
      ],
    },
    slide4: {
      image: '/slides/slide_04_he.png',
      hideOverlays: true,
      title: 'כיצד H2 ELEMENT משפר את יעילות המנוע שלך',
      steps: [
        { num: '1', title: 'אלקטרוליזה', body: 'לאחר הפעלת המנוע, הגנרטור מפעיל אלקטרוליזה לייצור גז HNO (תערובת מימן-חמצן).' },
        { num: '2', title: 'הזרקה', body: 'גז ה-HNO מסופק לתא הבעירה יחד עם אוויר ממסוף הצריכה.' },
        { num: '3', title: 'זרוז', body: 'גז ה-HNO הדליק מאוד מאיץ ומשפר את בעירת הדלק העיקרי.' },
        { num: '4', title: 'תוצאה', body: 'הדלק נשרף כמעט לחלוטין, מגדיל את היעילות התרמית של המנוע.' },
      ],
    },
    slide6before: 'לפני',
    slide6after: 'אחרי H2 ELEMENT',
    slide7: {
      image: '/slides/slide_07_he.png',
      hideOverlays: true,
      eyebrow: 'תאימות',
      title: 'פתרון אוניברסלי לכל סוגי מנועי הבעירה הפנימית',
      engineTypesTitle: 'סוגי מנוע נתמכים',
      vehicleTypesTitle: 'סוגי רכב נתמכים',
      engines: ['בנזין', 'דיזל', 'גז', 'מתאן\n(כולל HBO)'],
      vehicles: ['מכוניות פרטיות', 'משאיות מסחריות', 'טרקטורים חקלאיים', 'ציוד מיוחד'],
      footer: 'אנו בוחרים את דגם הגנרטור הספציפי על בסיס נפח המנוע שלך כדי להבטיח יעילות מקסימלית.',
    },
    slide11: {
      image: '/slides/slide_11_he.png',
      hideOverlays: true,
      title: 'זה לא עלות. זו השקעה ביעילות הצי שלך.',
      body: 'אנו יודעים שהצי שלך יכול לצרוך פחות דלק. לעסקים, צריכת דלק נמוכה יותר מתורגמת ישירות לשורת רווח בריאה יותר. ייעל את הפעילות שלך, הארך את חיי הרכבים שלך, וראה החזר ברור על ההשקעה עם H2 ELEMENT.',
      box: 'אנו עובדים עם יחידים, גופים משפטיים וסוכנויות ממשלתיות. שאל על התנאים שלנו לשותפויות עסקיות.',
      savings: 'חיסכון מצטבר',
      roi: 'ROI גדל',
      costs: 'עלויות דלק',
      time: 'זמן',
      axisY: 'עלות / חיסכון',
    },
    slide10: {
      headline: 'פשוט להתקנה, קל עוד יותר לתחזוקה.',
      installTitle: 'התקנה',
      maintainTitle: 'תחזוקה',
      installItems: [
        'לוקח רק 60–90 דקות.',
        'הוראות פשוטות צעד אחר צעד כלולות.',
        'יכול להיות מותקן על ידי כל חשמלאי רכב או מכונאי.',
        'המהנדסים שלנו תמיד זמינים לעזור.',
      ],
      maintainItems: [
        'אין צורך בידע מיוחד.',
        'משימה ראשונית: מילוי תקופתי במים.',
        'משימה משנית: שטיפת המערכת מדי פעם.',
        'אם תשכח — ייצור המימן נעצר וצריכת הדלק חוזרת לנורמלי. לא נגרם נזק.',
      ],
    },
  },
};
